import { useState } from "react";
import Lastmenu from "./LastMenu";
import bot from '../../assets/images/happy.png';
import you from '../../assets/images/boy.png';

const MetalCollection = () =>{

     const [time] = useState(new Date());
    
        const [showFrame1, setShowFrame1] = useState(false);
        const [selectedFrameName, setSelectedFrameName] = useState('');

    return(
        <>
            <div className="frame1 animated-frame" style={{textAlign: 'center'}}>
                <center><h2>Metal Collection</h2></center>
                <a href="https://agromech.com/collections/german-silver-items" target="_blank" rel="noopener noreferrer">
                    <button className="detatils-button2" onClick={() => {
                        setShowFrame1(true);
                        setSelectedFrameName("GERMAN SILVER ITEMS");
                        }}>GERMAN SILVER ITEMS</button>
                </a><br></br>
                <a href="https://agromech.com/collections/kansyam" target="_blank" rel="noopener noreferrer">
                <button className="detatils-button2" onClick={() => {
                        setShowFrame1(true);
                        setSelectedFrameName("Kansyam");
                        }}>Kansyam</button>
                        </a><br></br>

                <a href="https://agromech.com/collections/copper-items" target="_blank" rel="noopener noreferrer">
                <button className="detatils-button2" onClick={() => {
                       setShowFrame1(true);
                       setSelectedFrameName("COPPER ITEMS");
                        }}>COPPER ITEMS</button>
                        </a><br></br>
                <a href="https://agromech.com/collections/vara-laxmi-pooja-essentials" target="_blank" rel="noopener noreferrer">
                    <button className="detatils-button2" onClick={() => {
                        setShowFrame1(true);
                        setSelectedFrameName("Vara Laxmi Pooja Essentials");
                        }}>Vara Laxmi Pooja Essentials</button>
                </a>
            </div>
            {showFrame1 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                <div className="frame2">{selectedFrameName}</div>
                </div>
                <div className='chatbot'>
                <img src={bot} alt="bot" className="bot" />
                <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
            </div>
                    <Lastmenu />
                </>
            )}
            
        </>
    );

}
export default MetalCollection;